<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Edit Commodity</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help
                            you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="category">Category</label>
                                <div class="col-sm-6">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('category')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :options="categories"
                                                 @search-change="filterCategory"
                                                 class="form-control"
                                                 data-vv-as="Category"
                                                 id="category"
                                                 name="category"
                                                 placeholder="Search Category"
                                                 v-model="commodity.category"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.name }}</h5>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('category')">{{
                                        errors.first('category') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="name">Commodity
                                    Name</label>
                                <div class="col-sm-6">
                                    <input :class="{'is-invalid': submitted && errors.has('name')}"
                                           class="form-control"
                                           data-vv-as="name"
                                           id="name"
                                           name="name"
                                           placeholder="Commodity Name"
                                           type="text"
                                           v-model="commodity.name"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('name')">{{
                                        errors.first('name') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label"
                                       for="variety">Variety</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="Variety"
                                           id="variety"
                                           name="variety"
                                           placeholder="Goods/Services Variety"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="commodity.variety">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="native">Native
                                    Name</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="Native"
                                           id="native"
                                           name="native"
                                           placeholder="Goods/Services Native Name"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="commodity.native">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="unit">Quantity
                                    Units</label>
                                <div class="col-sm-6">
                                    <div :class="{'is-invalid': submitted && errors.has('unit')}"
                                         class="form-control p-0-0">
                                        <multiselect
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :hide-selected="true"
                                                :internal-search="false"
                                                :limit="3"
                                                :max-height="600"
                                                :options="units"
                                                :options-limit="300"
                                                :searchable="true"
                                                :selectLabel="''"
                                                :show-no-results="false"
                                                @input="setUnit"
                                                @search-change="getUnits"
                                                id="unit"
                                                label="name"
                                                name="unit"
                                                open-direction="bottom"
                                                placeholder="Search unit"
                                                track-by="id"
                                                v-model="commodity.unit">
                                            <template slot="singleLabel" slot-scope="props">
                                                {{props.option.name}}
                                            </template>
                                            <template slot="option" slot-scope="props">
                                                <div class="option__desc">
                                                    <h5>{{ props.option.symbol }}</h5>
                                                    <h5>{{ props.option.name }}</h5>
                                                </div>
                                            </template>
                                            <span slot="noResult">Unit not found</span>
                                        </multiselect>
<!--                                        <unit-select @unit-select="setUnit"-->
<!--                                                     data-vv-as="unit"-->
<!--                                                     ref="reference"-->
<!--                                                     id="unit"-->
<!--                                                     name="unit"-->
<!--                                                     v-model="commodity.unit_id"-->
<!--                                                     v-validate="'required'">-->
<!--                                        </unit-select>-->
                                    </div>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('unit')">{{
                                        errors.first('unit') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="description">Commodity
                                    Description</label>
                                <div class="col-sm-6">
                                    <textarea class="form-control"
                                              data-vv-as="description"
                                              id="description"
                                              name="description"
                                              placeholder="Commodity Description"
                                              rows=7
                                              v-model="commodity.description">
                                    </textarea>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="code">Commodity
                                    Code</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="code"
                                           id="code"
                                           name="code"
                                           placeholder="Commodity Code"
                                           type="text"
                                           v-model="commodity.code">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 text-right control-label col-form-label" for="hs_code">HS
                                    Code</label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           data-vv-as="hs_code"
                                           id="hs_code"
                                           name="hs_code"
                                           placeholder="HS Code"
                                           type="text"
                                           v-model="commodity.hs_code">
                                </div>
                                <div class="col-sm-3">
                                    <button class="btn waves-effect waves-light btn-outline-info" data-container="body"
                                            data-content="The HS (Harmonised System) or product code is used by customs officers worldwide to categorise products. See <a href='https://business.gov.nl/running-your-business/international-business/doing-business-abroad/using-the-correct-hs-code' target='_blank'>here for more info</a>"
                                            data-html="true"
                                            data-placement="top"
                                            data-toggle="popover"
                                            title="Harmonised Code"
                                            type="button">
                                        <i class="fas fa-info"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import Multiselect from "vue-multiselect";
    import categories from "@/data/commodityCatagories";

    // const categories = [
    //     {
    //         "name": "Others",
    //         "value": "OTHERS"
    //     },
    //     {
    //         "name": "Old",
    //         "value": "OLD"
    //     },
    //     {
    //         "name": "Service",
    //         "value": "SERVICE"
    //     },
    //     {
    //         "name": "Vegetables",
    //         "value": "VEGETABLES"
    //     },
    //     {
    //         "name": "Fruits",
    //         "value": "FRUITS"
    //     },
    //     {
    //         "name": "Dry Fruits",
    //         "value": "DRY_FRUITS"
    //     },
    //     {
    //         "name": "Food Grains",
    //         "value": "FOOD_GRAIN"
    //     },
    //     {
    //         "name": "Pulses",
    //         "value": "PULSES"
    //     },
    //     {
    //         "name": "Processed Items",
    //         "value": "PROCESSED_ITEMS"
    //     },
    //     {
    //         "name": "Spices",
    //         "value": "SPICES"
    //     },
    //     {
    //         "name": "Dairy",
    //         "value": "DAIRY"
    //     },
    //     {
    //         "name": "Edible Oils",
    //         "value": "EDIBLE_OILS"
    //     },
    //     {
    //         "name": "Salt Sugar Jaggery",
    //         "value": "SALT_SUGAR_JAGGERY"
    //     },
    //     {
    //         "name": "Beverages",
    //         "value": "BEVERAGES"
    //     },
    //     {
    //         "name": "Exotic",
    //         "value": "EXOTIC"
    //     },
    //     {
    //         "name": "Non Veg",
    //         "value": "NON_VEG"
    //     },
    //     {
    //         "name": "Animal Husbandry",
    //         "value": "Animal_Husbandry"
    //     }
    // ];

    export default {
        name: "EditCommodity",
        components: {Multiselect},
        props: ["commodityid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                units: [],
                categories: [],
                commodity: {
                    name: '',
                    description: '',
                    code: '',
                    hs_code: '',
                    variety: null,
                    native: null,
                    category: null,
                },
                file: File,
                filename: "No File Chosen",
                uploadstatus: ''
            };
        },
        mounted() {
            Vue.nextTick(function () {
                $('[data-toggle="popover"]').popover({trigger: 'focus'});
            });
            this.getCommodity();
        },
        methods: {
            async getUnits(searchText) {
                let row        = await this.$http.get('unit/search', {
                    params: {
                        search: searchText
                    }
                });
                this.units     = row.data;
            },
            async getCommodity() {
                try {
                    $(".preloader").fadeIn();
                    let row = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}`);
                    row.data.category = row.data.category ? categories.find(c => c.value === row.data.category) : null;
                    this.commodity = row.data;
                    this.commodity.unit_id = this.commodity.unit ? this.commodity.unit.id : null;
                } catch (e) {

                } finally {
                    $(".preloader").fadeOut();
                }
            },
            setUnit(e) {
                this.commodity.unit_id = e.id;
            },
            async save() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/${this.commodityid}`, {
                        name: this.commodity.name,
                        description: this.commodity.description,
                        code: this.commodity.code,
                        hs_code: this.commodity.hs_code,
                        variety: this.commodity.variety,
                        native: this.commodity.native,
                        category: this.commodity.category,
                        unit_id: this.commodity.unit_id
                    });
                    this.$router.go(-1);
                    this.$toastr('success', 'Commodity has been updated successfully.', 'Commodity Updated');
                } catch (e) {
                    console.error(e)
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.save();
                        }
                    }).catch(e => {
                    console.error(e)
                });
            },
            reset() {
                this.submitted = false;
                this.commodity = {
                    name: '',
                    description: '',
                    code: '',
                    hs_code: '',
                    variety: null,
                    native: null,
                    category: null,
                };
            },
            filterCategory(search) {
                this.categories = _.filter(categories, (c) => {
                    return c.name.toUpperCase().indexOf(search.toUpperCase()) != -1;
                });
            }
        }
    }
</script>

<style scoped>

</style>
